import { Component } from '@angular/core';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html'
})
export class NotFoundComponent {

  constructor() { }

}



// WEBPACK FOOTER //
// ./client/app/not-found/not-found.component.ts